import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
// src/modules/Users/hooks/useUser.ts
function useUser(args, opts = {}) {
	const fire = typeof opts.fire === "boolean" ? opts.fire : true;
	const { call, data, isCalling } = useRPC(RPCs.Users.GetUserProfile.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args?.userId && fire
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
export { useUser };

//# sourceMappingURL=useUser.js.map